import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { createUser } from '../../graphql/updateUsers';
import history from '../../config/history';
import { accountAdminRoute } from '../../config/navigation/routes';
import emailIsValidAndUnsassigned from '../../utils/asyncValidations';
import { updateOrganizationMembers } from '../Billsby/graphql';

export default function AddUserHOC(AddUserPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
        role: PropTypes.string,
      }).isRequired,

      refreshUsers: PropTypes.func.isRequired,
    };

    static initialState = {
      iconStatusIsHidden: true,
      alertType: '',
      alertMessage: '',
      initialValues: {
        fullName: '',
        email: '',
        phoneNumber: '',
        faxNumber: '',
        iconStatus: '',
        role: 'user',
      },
    };

    state = WrappedComponent.initialState;

    _onChangeRole = (role) => {
      if (role === "admin" || role === "super") {
        this.setState(prevState => ({
          initialValues: {
            ...prevState.initialValues,
            permissions: [1, 2, 3],
            role
          }
        }))
      }
      else {
        this.setState(prevState => ({
          values: {
            ...prevState.values,
            role
          }
        }))
      }
    }

    _onChangeField = (value, fieldname) => {
      this.setState(prevState => ({
        initialValues: {
          ...prevState.initialValues,
          [fieldname]: value
        }
      }))
    }

    _onSubmit = async event => {
      const { organizationId, cageCode } = this.props.auth;
      const { name, email, phoneNumber, faxNumber, iconStatus, permissions } = event;
      let { role } = event
      if (this.props.auth.role !== 'SUPER_ADMIN' && role === 'super') {
        role = 'admin'
      } else if (this.props.auth.role !== 'COMMON_ADMIN') {
        role = 'user'
      }

      // const role = this.props.auth.role !== 'SUPER_ADMIN' ? 'user' : event.role;
      const emailInUse = await emailIsValidAndUnsassigned(email)
      if (emailInUse) {
        this.setState({
          alertType: 'warning',
          alertMessage: emailInUse,
        });
        console.log("emailIsValidAndUnsassigned", emailInUse)
        return
      }

      try {
        await createUser({
          organizationId,
          name,
          email,
          role,
          phoneNumber,
          iconStatus,
          faxNumber,
          permissions,
          cageCode,
        });
        await updateOrganizationMembers(organizationId);
        this.setState({ alertType: 'success', alertMessage: 'User Created' });
        setTimeout(() => { this.props.refreshUsers(); this.returnToAccountAdmin() }, 2000);
      } catch (error) {
        this.setState({
          alertType: 'warning',
          alertMessage:
            'There was an error during submission, please try again in a few minutes',
        });
        console.error(error);
      }
    };

    returnToAccountAdmin = () => {
      // history.push(accountAdminRoute.replace(':page', 'viewUsers'))
      history.replace(accountAdminRoute.replace(':page', 'viewUsers'))
      // window.location.href = accountAdminRoute.replace(':page', 'viewUsers')
    }

    render() {
      const { initialValues, iconStatusIsHidden, alertType, alertMessage } = this.state;
      const { auth, refreshUsers } = this.props;

      const pageProps = {
        auth,
        initialValues,
        onSubmit: this._onSubmit,
        iconStatusIsHidden,
        alertType,
        alertMessage,
        onChangeRole: this._onChangeRole,
        onChangeField: this._onChangeField,
        returnToAccountAdmin: this.returnToAccountAdmin,
        refreshUsers,
      };
      return <AddUserPage {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/AddUser/AddUserHOC.jsx